/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_ApprovedInputs */

const en_wb_marketing_approved = /** @type {(inputs: Wb_Marketing_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example approved. The report would be saved with its sources and shared with the agreed reviewers.`)
};

const lv_wb_marketing_approved = /** @type {(inputs: Wb_Marketing_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piemērs apstiprināts. Atskaite tiktu saglabāta kopā ar avotiem un nosūtīta saskaņotajiem adresātiem.`)
};

/**
* | output |
* | --- |
* | "Example approved. The report would be saved with its sources and shared with the agreed reviewers." |
*
* @param {Wb_Marketing_ApprovedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_approved = /** @type {((inputs?: Wb_Marketing_ApprovedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_ApprovedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_approved(inputs)
	return en_wb_marketing_approved(inputs)
});